module.exports = __webpack_public_path__ + "img/183-Gris Sécurité Lisse.jpg";